<div *ngIf="field.editable else readOnly">
  <mat-form-field class="tw-w-full">
    <mat-select
      [formControl]="control"
      [ngClass]="{'ng-select-disabled': disabled}"
      [multiple]="true"
      (selectionChange)="onChange($event)"
    >
      <mat-option *ngFor="let option of dropdownList" [value]="option.value">{{option.label}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<ng-template #readOnly>
  <div>
    {{ field.value }}
  </div>
</ng-template>
